import { useMemo } from 'react'
import { useIsAPFreemium } from 'hooks/useIsAPFreemium'
import { useIsIntegrationsV3 } from 'hooks/useIsIntegrationsV3'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'
import { useAPMobileWeb } from './useAPMobileWeb'

export const useBottomItemsCount = (): number => {
  const isAPFreemium = useIsAPFreemium()
  const hideIntegrations = useIsIntegrationsV3()
  const isVirtualMarketer = useIsVirtualMarketer()
  const isAPMobileWeb = useAPMobileWeb()

  const count = useMemo<number>(() => {
    // Base items that are always shown:
    // - Refer & Earn
    // - Join our Community
    // - Invite Team Members
    // - Help & Learn Blaze
    let baseCount = 4

    // +1 if isAPFreemium is true (FreemiumUsageText)
    if (isAPFreemium && !isAPMobileWeb) {
      baseCount += 1
    }

    // +1 if hideIntegrations is false (Integrations item)
    if (!hideIntegrations) {
      baseCount += 1
    }

    // +1 if isVirtualMarketer is false (Templates item)
    if (!isVirtualMarketer) {
      baseCount += 1
    }

    if (isAPMobileWeb) {
      // -2 if isAPMobileWeb - no refer & earn, no invite team members
      baseCount -= 2
    }

    return baseCount
  }, [isAPFreemium, isAPMobileWeb, hideIntegrations, isVirtualMarketer])

  return count
}
